const REVIEW_RE = /(\[LEGAL REVIEW REQUIRED[^\]]*\])/g;
const EMAIL_RE = /([\w.+-]+@[\w.-]+\.\w+)/g;

function renderInline(text, keyPrefix) {
  return text.split(REVIEW_RE).map((part, i) => {
    if (part.startsWith("[LEGAL REVIEW REQUIRED")) {
      return (
        <mark
          key={`${keyPrefix}-r${i}`}
          data-testid="legal-review-marker"
          className="rounded bg-amber-200/70 px-1 py-0.5 font-mono-ui text-[11px] font-medium text-amber-900 dark:bg-amber-400/20 dark:text-amber-200"
        >
          {part}
        </mark>
      );
    }
    const nodes = [];
    let last = 0;
    let m;
    let j = 0;
    EMAIL_RE.lastIndex = 0;
    while ((m = EMAIL_RE.exec(part)) !== null) {
      if (m.index > last) nodes.push(part.slice(last, m.index));
      nodes.push(
        <a key={`${keyPrefix}-e${i}-${j}`} href={`mailto:${m[1]}`} className="text-foreground underline underline-offset-2">
          {m[1]}
        </a>
      );
      last = m.index + m[1].length;
      j += 1;
    }
    if (last < part.length) nodes.push(part.slice(last));
    return <span key={`${keyPrefix}-t${i}`}>{nodes}</span>;
  });
}

function isHeader(line) {
  const s = line.trim();
  if (s === "Contact Us") return true;
  if (!s || s.startsWith("- ")) return false;
  if (!/[A-Z]/.test(s)) return false;
  return s === s.toUpperCase() && s.length <= 90;
}

export const LegalBody = ({ body, className = "mt-8 space-y-6" }) => {
  const blocks = body.split(/\n\s*\n/);
  return (
    <div className={className}>
      {blocks.map((block, bi) => {
        const lines = block.split("\n");
        const out = [];
        let para = [];
        let list = [];
        const flushPara = () => {
          if (para.length) {
            const key = `p${bi}-${out.length}`;
            out.push(
              <p key={key} className="text-sm leading-relaxed text-muted-foreground">
                {renderInline(para.join(" "), key)}
              </p>
            );
            para = [];
          }
        };
        const flushList = () => {
          if (list.length) {
            const key = `u${bi}-${out.length}`;
            const items = list;
            out.push(
              <ul key={key} className="ml-5 list-disc space-y-1.5 text-sm leading-relaxed text-muted-foreground">
                {items.map((it, ii) => (
                  <li key={`${key}-${ii}`}>{renderInline(it, `${key}-${ii}`)}</li>
                ))}
              </ul>
            );
            list = [];
          }
        };
        lines.forEach((line) => {
          const s = line.trim();
          if (isHeader(line)) {
            flushPara();
            flushList();
            out.push(
              <h3 key={`h${bi}-${out.length}`} className="pt-1 font-display text-base font-semibold tracking-tight text-foreground">
                {s}
              </h3>
            );
          } else if (s.startsWith("- ")) {
            flushPara();
            list.push(s.slice(2));
          } else if (s !== "") {
            if (list.length && /^\s/.test(line)) {
              list[list.length - 1] += " " + s;
            } else {
              flushList();
              para.push(s);
            }
          }
        });
        flushPara();
        flushList();
        return (
          <div key={`blk-${bi}`} className="space-y-2">
            {out}
          </div>
        );
      })}
    </div>
  );
};
